import palette from '../palette';

export default {
  colorDefault: {
    color: palette.white,
    backgroundColor: palette.avatarFallbackColor,
  },
};
